export default "__VITE_ASSET__R3rX2nwT__"